import request from '@/utils/request';
//决策图测试查询
export function getSearch(param) {
  return request('/decision/diagram-execution', {
    method: 'GET',
    params: param,
  });
}

//决策图执行按钮
export function getImplement(values) {
  return request('/decision/diagram-execution', {
    method: 'POST',
    data: values,
  });
}
//编辑规则管理列表
export function editRuleManaList(values) {
  const { parentId } = values || {};
  values['parentId'] = null;
  return request(`/decision/rule/${parentId}`, {
    method: 'PUT',
    data: values,
  });
}
//删除规则管理列表
export function deleteRuleManaList(values) {
  const { id } = values || {};
  return request(`/decision/rule/${id}`, {
    method: 'DELETE',
    // data: values,
  });
}

// 决策图管理页面获取table接口
export function getGraphTable() {
  return request('/decision/diagram', {
    method: 'GET',
  });
}
// 决策图管理页面获取输入列表
export function getGraphInputList(param) {
  return request(`/decision/execute/meta-data/${param.strategyCode}`, {
    method: 'GET',
    params: { version: param.version },
  });
}
// 决策图管理页面获取输出列表
export function getGraphOutputList(values) {
  return request('/decision/diagram-execution', {
    method: 'POST',
    data: values,
  });
}
